package floris.graphics.models.dto.requests

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class MediaFileDto(
    val id: String = "",
    val url: String = "",
    @SerialName("mime_type")
    val mimeType: String = ""
)
